export default __webpack_public_path__ + "static/media/newsletter-example.20cdf3b8.jpg";